import { SPECIALTIES_ACTIONS } from "constants/Actions/Specialties";

// Estado inicial del reducer
const aInitialState = {
    aSpecialties: [],
    aSpecialtiesList: [],
    oSpecialty: null,

    bIsSuccess: false,
    bIsError: false,
}
/**
 * Reducer que será utilizado para controlar los datos referidos a las especialidades medicas almacenadas en el sistema.
 * 
 * @param {Array} aState Estado, si no recibe datos se setea el estado inicial
 * @param {object} oAction Action que es ejecutada
 * 
 * @returns {Array} Retorna un array que sera seteado en el estado del reducer
 * 
 * @author Leandro Curbelo 
 */
export const SpecialtyReducer = (aState = aInitialState, oAction) => {
    switch (oAction.type) {
        case SPECIALTIES_ACTIONS.GET:
            return { ...aState, aSpecialties: oAction.data };
        case SPECIALTIES_ACTIONS.GET_LIST:
            return { ...aState, aSpecialtiesList: oAction.data };
        case SPECIALTIES_ACTIONS.FIND:
            return { ...aState, oSpecialty: oAction.data };
        case SPECIALTIES_ACTIONS.SUCCESS:
            return { ...aState, bIsSuccess: true };
        case SPECIALTIES_ACTIONS.ERROR:
            return { ...aState, bIsError: true };
        case SPECIALTIES_ACTIONS.CLEAN:
            return { ...aState, bIsSuccess: false, bIsError: false, oSpecialty: null };
        default:
            return aState;
    }
}
